import { Anchor, Flex, Grid, Heading, Text } from "@govlaunch/web";
import Link from "next/link";
import React from "react";
import ChevronRight from "~/src/components/project/icons/ChevronRight";
import GovlaunchLogo from "~/src/components/project/icons/GovlaunchLogo";
import NotFoundIcon from "~/src/components/project/icons/NotFoundIcon";
import { FormattedMessage } from "react-intl";

export default function ProjectNotFound() {
  return (
    <Flex
      maxW={800}
      flexDir="column"
      margin="0 auto"
      backgroundColor="white"
      alignItems="center"
      borderRadius="md"
      border="solid 1px"
      borderColor="gray.100"
      py={24}
    >
      <Grid gridAutoFlow="column" alignItems="center" gridColumnGap={2} mb={20}>
        <GovlaunchLogo />

        <Heading color="gray.800">Govlaunch</Heading>
      </Grid>

      <NotFoundIcon />

      <Heading fontSize="100px" color="gray.600" mt={10} mb={3}>
        404
      </Heading>

      <Text color="gray.600" fontSize="2xl" fontWeight="bold" mb={8}>
        <FormattedMessage defaultMessage="The project you are looking for is not available" id="NKOV1M" />
      </Text>

      <Link href="/projects" passHref={true} legacyBehavior={true}>
        <Anchor
          fontSize="xl"
          display="grid"
          gridAutoFlow="column"
          gridColumnGap={2}
          justifyContent="center"
          fontWeight="semibold"
          alignItems="center"
        >
          <FormattedMessage defaultMessage="Go to all projects" id="568mZi" />

          <ChevronRight />
        </Anchor>
      </Link>
    </Flex>
  );
}
